import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Alumini.css';
import { FaChevronLeft, FaChevronRight, FaRegFilePdf, FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { Base_Url } from '../config';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

const NextArrow = ({ onClick }) => (
  <div
    className="custom-arrow next-arrow"
    onClick={onClick}
    style={{
      position: 'absolute',
      right: '-50px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '40px',
      height: '40px',
      backgroundColor: '#c21717',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 1,
      transition: 'background-color 0.3s ease'
    }}
  >
    <FaChevronRight style={{ color: 'white', fontSize: '20px' }} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="custom-arrow prev-arrow"
    onClick={onClick}
    style={{
      position: 'absolute',
      left: '-50px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '40px',
      height: '40px',
      backgroundColor: '#c21717',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 1,
      transition: 'background-color 0.3s ease'
    }}
  >
    <FaChevronLeft style={{ color: 'white', fontSize: '20px' }} />
  </div>
);

const NewsAndAnnouncements = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userfromwebmaster = useSelector((state) => state.user);
  const statecsc = useSelector((state) => state.statecsc);

  const fetchNews = async () => {
    try {
      const response = await axios.get(`${Base_Url}/newsandannouncement`);
      setNews(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch news and announcements');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const renderLink = (item) => {
    if (item.internal_link) {
      return (
        <Link to={item.internal_link} className="text-start">
          <button className="details-btn">
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "13px" }}>View More</span>
            </div>
          </button>
        </Link>
      );
    } else if (item.external_link) {
      return (
        <a
          href={item.external_link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-start"
        >
          <button className="details-btn">
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "13px" }}>View More</span>
            </div>
          </button>
        </a>
      );
    }
    return null;
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this news item?')) {
      return;
    }
    try {
      await axios.delete(`${Base_Url}/newsandannouncement/${id}`);
      alert('News deleted successfully!');
      fetchNews();
    } catch (err) {
      setError('Failed to delete news');
      console.error('Error deleting news:', err);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  const isAdmin = userfromwebmaster.userExists || statecsc.userState === 0;
  const hasNews = news.length > 0;

  // If there's no news and user is not admin, don't show anything
  if (!hasNews && !isAdmin) {
    return null;
  }

  return (
    <div className="alumni-container">
      {(hasNews || isAdmin) && (
        <div className="d-flex justify-content-center align-items-center">
          <h1 className="alumni-title text-uppercase mt-4 mb-4 d-flex align-items-center">
            <span style={{ color: "#686464" }}>News & </span>&nbsp;Announcements
            {isAdmin && (
              <div className="ms-3 d-flex gap-2">
                <Link to="/handlenewsannouncement" style={{ color: '#c21717', cursor: 'pointer' }}>
                  <FaPlus size={24} className="hover-effect" />
                </Link>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center">
              <Button
                variant="danger"
                size="sm"
                className="hoverviewmore ms-3"
                style={{
                  backgroundColor: "#c21717",
                  border: "none"
                }}
                onClick={() => navigate('/allnewsandannouncement')}
              >
                View All
              </Button>
            </div>
          </h1>
        </div>
      )}

      {hasNews ? (
        <div className="slider-container">
          <Slider {...settings} className="alumni-slider">
            {news.map((item) => (
              <div key={item.id} className="alumni-card-wrapper">
                <div className="alumni-card" style={{ position: 'relative' }}>
                  {isAdmin && (
                    <>
                      <Link 
                        to={`/handlenewsannouncement/${item.id}`} 
                        style={{ 
                          position: 'absolute',
                          top: '10px',
                          right: '10px',
                          color: '#c21717',
                          cursor: 'pointer',
                          zIndex: 2,
                          backgroundColor: 'rgba(52, 188, 230, 0.8)',
                          borderRadius: '50%',
                          padding: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <FaEdit size={20} className="hover-effect text-primary" />
                      </Link>
                      
                      <FaTrash 
                        style={{ 
                          position: 'absolute',
                          top: '10px',
                          right: '40px',
                          color: '#c21717',
                          cursor: 'pointer',
                          zIndex: 2,
                          backgroundColor: 'rgba(107, 101, 101, 0.8)',
                          borderRadius: '50%',
                          padding: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} 
                        size={30} 
                        onClick={() => handleDelete(item.id)} 
                        className="hover-effect"
                      />
                    </>
                  )}
                  <div className="alumni-image-container">
                    <img
                      src={`${Base_Url}/${item.image_path}`}
                      alt={item.title}
                      className="alumni-image"
                      onError={(e) => {
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="alumni-info">
                    <h2 className="text-start">{item.title}</h2>
                    <p className="awardss mb-1 text-start" style={{ color: "#2e4e7e" }}>
                      {item.description}
                    </p>
                    {renderLink(item)}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : isAdmin ? (
        <div className="text-center py-4">
          <p>No news available. Click the + icon to add news.</p>
        </div>
      ) : null}
    </div>
  );
};

export default NewsAndAnnouncements;